module.exports = "data:image/gif;base64,R0lGODlhCgAKAIAAAEcTFqOYmyH5BAAAAAAALAAAAAAKAAoAAAIShI8Qy2vdHnQq1YuCnBv2aCEFADs="